// Simple deterministic color assignment per identifier
// Usage: colorForId('user@example.com') => 'hsl(210, 65%, 48%)'

export function hashString(str) {
  let h = 2166136261 >>> 0; // FNV-1a
  for (let i = 0; i < (str || "").length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

export function colorForId(id, { s = 65, l = 48 } = {}) {
  const h = hashString(String(id || "")).toString(10);
  // map hash to 0..360 using modulo
  const hue = parseInt(h, 10) % 360;
  return `hsl(${hue}, ${s}%, ${l}%)`;
}

export function textColorForBgHsl(hsl) {
  // crude parse to get lightness
  const m = /hsl\(\s*\d+\s*,\s*(\d+)%\s*,\s*(\d+)%\s*\)/.exec(hsl || "");
  const l = m ? Number(m[2]) : 50;
  return l < 55 ? "#fff" : "#111";
}
